import { styled } from '@abyss/web/tools/styled';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

export const StyledDrawer = styled(Drawer, {
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
    marginTop: '24px',
  },
  '.abyss-modal-content-container': {
    borderRadius: 0,

    '@screen < $md': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$primary1',
      border: '1px solid $primary1',
    },
  },
  '.abyss-modal-close-button': {
    '@screen < $md': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-content-title': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '32.43px',
    lineHeight: '40px',
    paddingTop: '0px',
  },
  '.abyss-modal-body': {
    padding: '0px 16px 16px 16px',
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '.abyss-modal-footer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px',
    '@screen < $md': {
      paddingBottom: '30px',
    },
  },
});

export const LayoutGroupStyled = styled(Layout.Group, {
  dynamic: ({ cssProps: { bool, index } }) => ({
    minHeight: '30px',
    flexDirection: 'row',
    alignItems: 'center',
    margin: bool ? '16px 0px' : '0px',
    marginTop: index === 0 || !bool ? '0px' : '16px',
    border: bool ? '2px solid #196ECF' : '0px',
    padding: '8px 16px',
    borderRadius: '4px',
  }),
});

export const ProviderNameWithScore = styled(Flex, {
  alignItems: 'start',
  flexDirection: 'column',
});

export const SmartChoiceScore = styled(Text, {
  '&.abyss-text-root': {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: '$success1',
    fontWeight: '$bold',
    lineHeight: '18px ',
    fontSize: '14px',
  },
});

export const AvatarProviderCard = styled('div', {
  width: '49px',
  height: '49px',
  minWidth: '49px',
  minHeight: '49px',
  borderRadius: '50%',
  overflow: 'hidden',
});

export const HorizontalLine = styled('div', {
  width: '100%',
  height: '1px',
  backgroundColor: '#E5E5E6',
  margin: '8px 0',
});
